import script from "./MirrorProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./MirrorProfile.vue?vue&type=script&setup=true&lang=js"

import "./MirrorProfile.vue?vue&type=style&index=0&id=0a862b5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a862b5e"]])

export default __exports__